/**
 * @author 友人a丶
 * @date
 *
 * */


/*数据接口*/
import echarts from '@/common/init-echarts';
import {getDays} from "@/common";
import {inject, onMounted, ref, watch} from "vue";
import load from "@/common/load";
import axios from "axios";


export default function (props) {


    const dom = ref(null); //真实DOM
    const range = inject('range');//时间范围
    let myChart;


    /*图表的数据*/
    function setOption(days, data) {

        const selected = {};
        selected[props.title[0]] = true;
        selected[props.title[1]] = true;

        const option = {
            color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                data: props.title,
                selected: selected
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title: "保存为图片"
                    }
                }
            },
            grid: {
                left: '1%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: days,
                    /* 倾斜角度为 -45 度 */
                    /* axisLabel: {
                         rotate: -45
                     }*/
                }
            ],
            yAxis: [
                {
                    name: props.title[0],
                    type: 'value',
                    // 关闭 y 轴上的刻度线
                    /*splitLine: {
                        show: false,
                    },*/
                    min: Math.min.apply(null, data[0])
                },
                {
                    name: props.title[1],
                    type: 'value',
                    min: Math.min.apply(null, data[1])
                }
            ],
            series: [
                {
                    name: props.title[0],
                    type: 'line',
                    stack: 'Total',
                    /* 线条颜色 */
                    lineStyle: {
                        color: '#22b7ff',
                        width: 3
                    },
                    /* 数值标签 */
                    label: {
                        show: true,
                        position: 'top'
                    },
                    zlevel: 2,
                    z: 2,
                    showSymbol: true,
                    emphasis: {
                        focus: 'series'
                    },
                    data: data[0]
                },
                {
                    name: props.title[1],
                    type: 'line',
                    stack: 'Total',
                    yAxisIndex: 1,
                    lineStyle: {
                        color: '#b84fd1',
                        width: 3
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    zlevel: 2,
                    z: 2,
                    showSymbol: true,
                    emphasis: {
                        focus: 'series'
                    },
                    data: data[1]
                },
            ]
        };

        myChart.setOption(option)
    }

    /**
     * 数据处理
     * */
    const process = (days, res) => {

        /*数据*/
        let data = [[], []];
        /**
         * 遍历每一天
         * */
        for (let i of days) {
            /**
             * 遍历所有数据
             * */
            let temp = 0;
            let comment = 0;

            for (let k of res[0]) {
                if (i === k.datetime) {
                    temp = k.count;
                }
            }

            for (let k of res[1]) {
                if (i === k.datetime) {
                    comment = k.count;
                }
            }

            data[0].push(temp); //存入数据
            data[1].push(comment); //存入数据
        }

        return data;
    }


    /**
     * 请求网络数据
     * */
    const requests = () => {

        /*获取时间范围*/

        const days_week = getDays(range.value[0], range.value[1], "MM-DD", props.hasEnd);
        const days = getDays(range.value[0], range.value[1], "YYYY-MM-DD", props.hasEnd);


        /*判断选择的时间*/
        if (days.length === 0) {
            return;
        }

        load.loading("初始化图表数据...");

        axios.post(`${props.api}`, {
            start: range.value[0].format("YYYY-MM-DD"),
            end: range.value[1].format("YYYY-MM-DD")
        })
            .then((res) => {

                /*判断请求结果*/
                if (res.data.code === 1) {
                    setOption(days_week, process(days, res.data.data[0])); //渲染表格
                } else {
                    load.error(res.data.errMsg);
                }

            }).catch((e) => {
            load.error(e.message);
        }).finally(() => {
            load.loaded();
        })
    }


    /**
     * 时间范围发生变化时，重新请求数据
     * */
    watch(() => range, requests, {
        deep: true
    });

    /**
     * 初始化图表
     * */
    onMounted(() => {
        myChart = echarts.init(dom.value)
        requests(); //初始化数据
    })

    return dom;


}